module.exports = __webpack_public_path__ + "static/media/apple-wallet.6fc3081f.svg";